import styled from 'styled-components'
import { BREAKPOINTS, media, Theme } from '@web-apps/ui-shared'

/**
 * Publishes the space the sidebar takes up as CSS variables, so the fixed
 * elements rendered further down the tree (page header, tab list) can clear it
 * without every one of them having to know whether the sidebar is rendered.
 * They fall back to the full sidebar size when used outside this layout.
 */
export const StyledAppWrapper = styled.div<{ $hasSidebar: boolean }>`
  --sidebar-width: ${({ $hasSidebar }) =>
    $hasSidebar ? Theme.Sidebar.width : 0}px;
  --sidebar-height: ${({ $hasSidebar }) =>
    $hasSidebar ? Theme.Sidebar.height : 0}px;
`

export const StyledContainer = styled.div<{
  $isSafariIOS: boolean
}>`
  ${({ $isSafariIOS }) => {
    return (
      $isSafariIOS &&
      `
        padding-bottom: 100px;
     `
    )
  }}
  margin-left: var(--sidebar-width, ${Theme.Sidebar.width}px);
  background-color: ${Theme.CreatorApp.backgroundColor};
  display: flex;
  flex-flow: column;
  min-height: calc(100vh - ${Theme.CreatorApp.header.height}px);
  position: relative;
  margin-top: 64px;
  padding-bottom: var(--sidebar-height, ${Theme.Sidebar.height}px);

  ${media.to(
    BREAKPOINTS.md,
    `
    height: calc(100vh - ${Theme.CreatorApp.header.height}px);
    overflow-y: auto;
    overflow-x: hidden;
    margin-left: 0;
    `
  )}
`
